import type { Theme } from "@lib/theme"
import { Monitor, Moon, Sun } from "lucide-react"
import type { ComponentType } from "react"

export interface ThemeOption {
  value: Theme
  labelKey: string
  icon: ComponentType<{ className?: string }>
}

export const THEME_OPTIONS: ReadonlyArray<ThemeOption> = [
  { value: "system", labelKey: "theme.system", icon: Monitor },
  { value: "light", labelKey: "theme.light", icon: Sun },
  { value: "dark", labelKey: "theme.dark", icon: Moon },
] as const
